import axios from "axios";
import * as GlobalService from '../../../../global_services';

export const SkuInfo = function (param_customerid, param_item_id) {
    return axios.get('/WebUI/Shipping/Orders/SkuInfo?customerId='+param_customerid+"&itemId="+param_item_id).then(function (response) {
        return response;
    });
}
export const addLineItem = function (params) {
    const validateOveralloc = getValidateOveralloc();

    return axios.post('/WebUI/Shipping/Orders/OrderItem?validateOveralloc=' + validateOveralloc, params).then(function (response) {
        return response;
    });
}
export const editLineItem = function (params) {
    const validateOveralloc = getValidateOveralloc();

    return axios.put('/WebUI/Shipping/Orders/OrderItem?validateOveralloc=' + validateOveralloc, params).then(function (response) {
        return response;
    });
}

function getValidateOveralloc() {
    const rights = GlobalService.GetRights();
    const validateOveralloc = rights.hasOwnProperty('orders.edit.overalloc') ? !rights['orders.edit.overalloc'] : true;
    return validateOveralloc;
}
